/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const FlightSearchErrorDetail = {
    InvalidIata: 'invalid_iata',
    DuplicatePointsSources: 'duplicate_points_sources',
    DepartureDateInPast: 'departure_date_in_past',
    ReturnDateInPast: 'return_date_in_past',
    ProviderFetchFailed: 'provider_fetch_failed',
    ProviderBlocked: 'provider_blocked',
    ResponseParseFailed: 'response_parse_failed',
    RoundTripUnsupported: 'round_trip_unsupported',
    UnexpectedProviderError: 'unexpected_provider_error',
    DuffelApiError: 'duffel_api_error'
} as const;
export type FlightSearchErrorDetail = typeof FlightSearchErrorDetail[keyof typeof FlightSearchErrorDetail];


export function instanceOfFlightSearchErrorDetail(value: any): boolean {
    for (const key in FlightSearchErrorDetail) {
        if (Object.prototype.hasOwnProperty.call(FlightSearchErrorDetail, key)) {
            if (FlightSearchErrorDetail[key as keyof typeof FlightSearchErrorDetail] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightSearchErrorDetailFromJSON(json: any): FlightSearchErrorDetail {
    return FlightSearchErrorDetailFromJSONTyped(json, false);
}

export function FlightSearchErrorDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSearchErrorDetail {
    return json as FlightSearchErrorDetail;
}

export function FlightSearchErrorDetailToJSON(value?: FlightSearchErrorDetail | null): any {
    return value as any;
}

export function FlightSearchErrorDetailToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightSearchErrorDetail {
    return value as FlightSearchErrorDetail;
}
